/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Cta_EyebrowInputs */

const es_l7_cta_eyebrow = /** @type {(inputs: L7_Cta_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin compromiso`)
};

const gl_l7_cta_eyebrow = /** @type {(inputs: L7_Cta_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sen compromiso`)
};

const en_l7_cta_eyebrow = /** @type {(inputs: L7_Cta_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No obligation`)
};

/**
* | output |
* | --- |
* | "No obligation" |
*
* @param {L7_Cta_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_cta_eyebrow = /** @type {((inputs?: L7_Cta_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Cta_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_cta_eyebrow(inputs)
	if (locale === "en") return en_l7_cta_eyebrow(inputs)
	return es_l7_cta_eyebrow(inputs)
});